// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Mahai "Legal Sage" teması — kürsü yeşili + mühür altını.
// Token'ların CSS tarafı: src/assets/scss/_tokens.scss
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "mahaiLight",
    themes: {
      mahaiLight: {
        dark: false,
        colors: {
          primary: "#1A5F4A",
          secondary: "#C9A227",
          background: "#F6F7F3",
          surface: "#FFFFFF",
          success: "#1A5F4A",
          warning: "#B4530A",
          error: "#9B3B22",
          info: "#0E3A2D",
        },
      },
    },
  },
});

export default vuetify;
